import React from 'react';
import { HelpTooltip } from '../HelpTooltip';
import {
  StyledFormLabelContainer,
  StyledLabel,
  StyledPlaceholder,
  StyledRequiredMark,
} from './styles';

type FormLabelProps = {
  label?: string | React.ReactNode;
  required?: boolean;
  help?: React.ReactNode;
};

export function FormLabel(props: Readonly<FormLabelProps>) {
  const { label, required, help } = props;

  return (
    <StyledFormLabelContainer>
      {label ? (
        <StyledLabel>
          {label} {required ? <StyledRequiredMark>*</StyledRequiredMark> : null}
        </StyledLabel>
      ) : (
        <StyledPlaceholder />
      )}
      {help ? <HelpTooltip help={help} /> : <StyledPlaceholder />}
    </StyledFormLabelContainer>
  );
}
